import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Users, Calendar, BookOpen, ArrowRight } from "lucide-react";

export default function Preinscripcion() {
  const options = [
    { value: "/campamento-verano/campamento-urbano", label: "Campamento Urbano 2027", desc: "Solicitar aviso de la próxima edición urbana", icon: Calendar, color: "#1B5F7E", bg: "#EBF5FB" },
    { value: "/campamento-verano", label: "Campamento de Verano (8-18 años)", desc: "Solicitar aviso de la próxima edición", icon: Users, color: "#2B87BE", bg: "#EBF5FB" },
    { value: "/encuentro-adultos", label: "Encuentro Adultos (septiembre 2026)", desc: "Formulario de contacto en la página del encuentro", icon: Calendar, color: "#2D6A4F", bg: "#E8F4EC" },
    { value: "/cursos-especializados", label: "Extraescolares", desc: "Formulario de información en la página de extraescolares", icon: BookOpen, color: "#C9974A", bg: "#FBF3E3" },
  ];

  return (
    <main data-testid="preinscripcion-page" style={{ fontFamily: "Manrope, sans-serif" }}>
      <section className="pt-32 pb-16 px-5 lg:px-8" style={{ background: "#F8FAFC" }}>
        <div className="max-w-2xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="section-label mb-5">Inscripción</div>
            <h1 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F", lineHeight: 1.2 }} className="text-4xl md:text-5xl font-bold mb-5">
              ¿En qué experiencia<br /><em style={{ color: "#1B5F7E" }}>te inscribes?</em>
            </h1>
            <p className="text-slate-500 leading-relaxed">Selecciona la experiencia que te interesa y accede al formulario correspondiente.</p>
          </motion.div>
        </div>
      </section>

      <section className="py-12 pb-32 px-5 lg:px-8" style={{ background: "#FFFFFF" }}>
        <div className="max-w-2xl mx-auto space-y-4">
          {options.map((opt) => (
            <Link key={opt.value} to={opt.value} data-testid={`preinscripcion-link-${opt.value}`}
              className="flex items-center gap-5 p-6 rounded-2xl border-2 transition-all hover:shadow-lg group"
              style={{ borderColor: "#E2E8F0", background: "white" }}
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: opt.bg }}>
                <opt.icon size={22} style={{ color: opt.color }} />
              </div>
              <div className="flex-1">
                <span className="text-sm font-semibold block" style={{ color: "#0D3A4F" }}>{opt.label}</span>
                <span className="text-xs text-slate-400">{opt.desc}</span>
              </div>
              <ArrowRight size={16} className="text-slate-300 group-hover:text-slate-500 transition-colors" />
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
